import { ChangeDetectorRef, Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { ThaiDateTimePipe } from '../../../shared/commons/thai-datetime.pipe';

import { firstValueFrom } from 'rxjs';
import { ActivityLogDto } from '../../../../generated-model/models';
import { ActivityLogListService } from './activity-log-list.service';
import { ConfirmDialogService } from '../../../shared/ui/confirm-dialog/confirm-dialog.service';

import { resolveTotalElements } from '../../../shared/commons/pagination.util';
import { PageTitleComponent } from '../../../shared/commons/page-title/page-title.component';
import { PagesizeSelectComponent } from '../../../shared/components/pagesize-select/pagesize-select.component';

@Component({
  selector: 'app-activity-log-list',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbPagination, ThaiDateTimePipe, PageTitleComponent, PagesizeSelectComponent],
  templateUrl: './activity-log-list.component.html',
  styleUrl: './activity-log-list.component.scss'
})
export class ActivityLogListComponent implements OnInit {
  private readonly service = inject(ActivityLogListService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly modalService = inject(NgbModal);
  private readonly confirmDialogService = inject(ConfirmDialogService);

  protected readonly searchQuery = signal('');
  protected readonly isLoading = signal(false);
  protected readonly page = signal(1);
  protected readonly pageSize = signal(10);
  protected readonly collectionSize = signal(0);
  protected readonly displayedItems = signal<ActivityLogDto[]>([]);

  private totalElements = 0;

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.isLoading.set(true);
    this.service.getAll(this.page() - 1, this.pageSize(), this.searchQuery()).subscribe({
      next: (data) => {
        this.displayedItems.set(data.content);
        this.totalElements = resolveTotalElements(data);
        this.collectionSize.set(this.totalElements);
        this.isLoading.set(false);
        this.cdr.detectChanges();
      },
      error: () => {
        this.isLoading.set(false);
        this.cdr.detectChanges();
      }
    });
  }

  onSearchChange(): void {
    this.page.set(1);
    this.load();
  }

  clearSearch(): void {
    this.searchQuery.set('');
    this.onSearchChange();
  }

  async delete(id: number): Promise<void> {
    const confirmed = await this.confirmDialogService.confirmDelete('คุณต้องการลบข้อมูลนี้ใช่หรือไม่?');
    if (!confirmed) {
      return;
    }
    this.service.delete(id).subscribe(() => this.load());
  }

  getResultLabel(result?: string): string {
    if (!result) return '-';
    const map: Record<string, string> = { success: 'Success', error: 'Error' };
    return map[result.toLowerCase()] ?? result;
  }

  getResultTone(result?: string): string {
    if (!result) return '';
    return result.toLowerCase() === 'success' ? 'success' : 'danger';
  }
}
